let Vue = require('vue');

let guid = require('sci/helpers/guid');

let nullify = (value) => {
    if (value === "") {
        return null;
    }

    return value;
};

let buildSelect2 = (self, cb, value) => {
    let key = self.params.display || 'text';
    let id = self.params.identifier || 'id';

    let elOptions = [];
    if (Array.isArray(self.params.options)) {
        elOptions = self.params.options;
    }

    let options = elOptions.map(function (item) {
        return {
            original: item,
            text: item[key],
            id: item[id],
            disabled: item.$disabled
        };
    });

    $(self.el)
        .prop('disabled', self.params.disabled)
        .empty()
        .unbind()
        .select2({
            language: {
                errorLoading: function () {
                    return 'Os resultados não puderam ser carregados.'
                },
                inputTooLong: function (args) {
                    const overChars = args.input.length - args.maximum

                    let message = 'Apague ' + overChars + ' caracter'

                    if (overChars !== 1) {
                        message += 'es'
                    }

                    return message
                },
                inputTooShort: function (args) {
                    const remainingChars = args.minimum - args.input.length

                    return 'Digite ' + remainingChars + ' ou mais caracteres'
                },
                loadingMore: function () {
                    return 'Carregando mais resultados…'
                },
                maximumSelected: function (args) {
                    let message = 'Você só pode selecionar ' + args.maximum + ' ite'

                    if (args.maximum === 1) {
                        message += 'm'
                    } else {
                        message += 'ns'
                    }

                    return message
                },
                noResults: function () {
                    return 'Nenhum resultado encontrado'
                },
                searching: function () {
                    return 'Buscando…'
                }
            },
            tags: self.params.editable,
            //dropdownParent: $(self.el).parents('.form-group'),
            //minimumResultsForSearch: 5,
            id: guid(),
            theme: "bootstrap",
            dropdownAutoWidth: true,
            width: 'auto',
            data: options,
            allowClear: self.params.allowEmpty,
            placeholder: {
                id: null,
                text: self.params.placeholder || "Selecione..."
            }
        })
        .on('change', function () {
            cb.apply(this, arguments);
        });

    $(self.el).val(value).trigger('change', true);
};

Vue.directive('select', {
    twoWay: true,
    priority: 1000,


    params: ['options', 'identifier', 'display', 'on-change', 'allow-empty', 'disabled', 'placeholder'],

    paramWatchers: {
        disabled: function () {
            $(this.el).prop('disabled', this.params.disabled);
        },
        options: function (val, oldVal) {
            let self = this;

            buildSelect2(this, function (evt, ignore) {
                if (ignore) {
                    return;
                }
                if (self.params.onChange) {
                    let realValue = $(this).select2('data')[0];
                    self.params.onChange(this.value, realValue ? realValue.original : null);
                }
                self.set(nullify(this.value));
            }, self.currentValue);
        }
    },
    bind: function () {
        // let self = this;
        // buildSelect2(this, function () {
        //     if (self.params.onChange) {
        //         self.params.onChange(this.value);
        //     }
        //     self.set(nullify(this.value));
        // }, self.currentValue);
    },
    update: function (value) {
        let self = this;

        self.currentValue = value;

        buildSelect2(this, function (evt, ignore) {
            if (ignore) {
                return;
            }
            if (self.params.onChange) {
                let realValue = $(this).select2('data')[0];
                self.params.onChange(this.value, realValue ? realValue.original : null);
            }
            self.set(nullify(this.value));
        }, self.currentValue);
    },
    unbind: function () {
        $(this.el).off().select2('destroy')
    }
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/select2.js